import styled from "styled-components";

import { TicketCardContainerStyledProps as Props } from "./TicketCardContainer.types";
import CONSTANTS from "config/constants";

const { tablet, mobile } = CONSTANTS.BREAKPOINTS;

const TicketCardContainerStyled = styled.div<Props>`
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 3.2rem;
  border-radius: 1rem;
  background-color: var(--palette-mid-blue-s15-l20);

  .TicketCardContainer {
    &__dot-container {
      position: absolute;
      justify-content: center;
      top: 50%;
      transform: translateY(-50%);

      @media (max-width: ${tablet}px) {
        top: 3.2rem;
      }

      @media (max-width: ${mobile}px) {
        top: 4rem;
      }
    }

    &__dot {
      width: 3.2rem;
      height: 3.2rem;
      background-color: var(--palette-dark-blue-s13-l11);
      border-radius: 12rem;
    }

    &__left-dot-container {
      left: -1.6rem;
    }

    &__right-dot-container {
      right: -1.6rem;
    }
  }
`;

export default TicketCardContainerStyled;
